import { useJob } from "@vidario/api-client";
import { formatDateLongDE } from "@vidario/domain";
import { Breadcrumb } from "@vidario/ui";
import { type ReactElement } from "react";
import { useNavigate, useParams } from "react-router";

import { RecommendationPanel } from "./RecommendationPanel";

/** Empfehlungsseite (MVP §4 Screen 5). Thin wrapper around the shared
 * {@link RecommendationPanel}. The same panel is rendered as the third
 * tab of the Longlist page once the job reaches the Empfehlung step. */
export function RecommendationRoute(): ReactElement {
  const { jobId = "" } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const { data: job } = useJob(jobId);

  if (!job) {
    return (
      <main className="mx-auto max-w-[var(--container-max)] px-4 py-10 sm:px-8">
        <p className="text-sm text-text-secondary" role="status">
          Lade Empfehlung…
        </p>
      </main>
    );
  }

  return (
    <main className="mx-auto max-w-[var(--container-max)] px-4 py-10 sm:px-8 pb-20">
      <Breadcrumb
        className="mb-5"
        items={[
          { label: "Dashboard", onClick: () => void navigate("/dashboard") },
          {
            label: job.title,
            onClick: () => void navigate(`/jobs/${jobId}/longlist`),
          },
          { label: "Empfehlung" },
        ]}
      />

      <div className="mb-6 flex flex-wrap items-start justify-between gap-6">
        <div className="min-w-0 flex-1 basis-[300px]">
          <div className="mb-1 text-xs font-medium uppercase tracking-wider text-text-tertiary">
            Kandidaten-Empfehlung
          </div>
          <h1 className="m-0 text-[2.25rem] font-bold leading-[1.1] -tracking-[0.5px]">
            {job.title}
          </h1>
          <div className="mt-2 text-sm text-text-secondary">
            Für <b>{job.company}</b> · Erstellt am {formatDateLongDE(job.createdAt)}
          </div>
        </div>
      </div>

      <RecommendationPanel jobId={jobId} />
    </main>
  );
}
